import { Fv, Problem, Reason, Service, Works, Flow, Banner, News, Contact } from "../components/Project";
import { Grid, Space } from "../components/Layout";
import { Media } from "../components/Object";

const Home = () => {

  return (
    <>
      <Fv></Fv>
      <Space size={['96px', '48px']} />

      <Space size={['80px', '64px']} />
      <Problem />
      <Space size={['80px', '64px']} />
    
      <Space size={['104px', '64px']} />
      <Reason />
      <Space size={['90px', '64px']} />

      <Space size={['104px', '64px']} />
      <Service />
      <Space size={['80px', '64px']} />
    
      <Space size={['120px', '80px']} />
      <Works />
      <Space size={['120px', '80px']} />
    
      <Flow />
      <Space size={['120px', '80px']} />

      <Banner />
      <Space size={['120px', '80px']} />

      <News></News>
      <Space size={['184px', '120px']} />

      {/* <Contact></Contact> */}
    </>
  );
};

export default Home;
